module.exports = __webpack_public_path__ + "img/logo2.5ed85038.png";